import { render, staticRenderFns } from "./resultDetailsLmsStu.vue?vue&type=template&id=4090cc24&"
import script from "./resultDetailsLmsStu.vue?vue&type=script&lang=js&"
export * from "./resultDetailsLmsStu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports